import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentsService} from "../../services/agents-service.service";
import {AgentModel} from "../../angular/models/agent.model";
import {ItinerariesService} from "../../../itineraries/services/itineraries-service.service";
import {LocationHolderType} from "../../../commons/types/locationHolder.type";
import {LogisticsVehicle} from "../../../logistics-vehicle/models/logistics-vehicle.model";
import {LocationService} from "../../../commons/services/location-service.service";
import {LocationModel} from "../../../commons/models/location.model";
import {LogisticsVehicleService} from "../../../logistics-vehicle/services/logistics-vehicle-service.service";
import {
  LogisticsVehiclesDialogsService
} from "../../../logistics-vehicle/services/logistics-vehicles-dialogs-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {$bringozLocationsFactory} from "../../../commons/$bringozLocations.factory";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {LocationsFacadeService} from "../../../commons/angular/services/locations/locations-facade.service";
import {Subscription} from "rxjs";
import {ItinerariesFacadeService} from "../../../itineraries/angular/services/itineraries-facade.service";
import {ItineraryModel} from "../../../itineraries/angular/models/itinerary.model";


export class AgentItineraryViewCtrl implements IController {

  agent: AgentModel;
  showAgentInfo: any;

  onAgentSelect: Function;
  onClose: Function;

  private showMap: boolean;
  private tasksRef: any;
  private itinerariesRef: any;
  private inActiveStatuses: any;
  private completedStatuses: any;
  private $tasksOrigin: any;
  private itineraryCopy: any;

  private itinerary: ItineraryModel;
  private relatedItineraries: any;
  private itineraryTotals: any;
  private tasks: any;
  private inActiveTasks: any;
  private relatedTasks: any;
  private hiddenAgentIds: any;
  private relatedCompletedTasks: any;
  private isEditMode: boolean;
  private highlightedServiceId: any;
  private editModeHasItineraryChanged: boolean;
  private highlightedTaskId: any;
  private isExpandedTasks: boolean;
  private inActiveTasksDateQuery: boolean;
  private selectedTasksGroup: any;
  private userNameId: any;
  private agentServiceAreas: any;
  private serviceAreasPolygons: any;
  public itineraryAgentId: any;
  public serviceAreasRef: any;

  private logisticsVehiclesRef: any;
  public logisticsVehicles: LogisticsVehicle[];
  public attachedLogisticsVehicles: LogisticsVehicle[];
  private hasLogisticsVehiclePermission: boolean;
  private completedRouteTasksData: number;
  private pushesTimeoutRef: any;
  private maxUserIdleTimeMinutes: number;
  private selectLocationsSubscription: Subscription;
  private locationIds: string[];
  public itinerarySubscription: Subscription;

  constructor(private itinerariesService: ItinerariesService, private agentRequests: AgentRequests, private agentsService: AgentsService, private $task,
              private resizeService: ResizeService, private IAMPermissions, private locationService: LocationService, private $logisticsVehicle,
              private commonsService: CommonsService, private logisticsVehicleService: LogisticsVehicleService, private commonsDialogService: CommonsDialogService,
              private logisticsVehiclesDialogsService: LogisticsVehiclesDialogsService, private splitService: SplitService, private $itineraries,
              private itinerariesConstant, private $log, private moment, private $timeout: ITimeoutService, private UserService, private $serviceArea,
              private routesService: RoutesService, private $q, private locationsFacadeService: LocationsFacadeService, private itinerariesFacadeService: ItinerariesFacadeService) {
    // this.itinerariesRef = this.$itineraries();
    this.logisticsVehiclesRef = this.$logisticsVehicle();
    this.hasLogisticsVehiclePermission = this.IAMPermissions.hasPermission('vehicleInstance.logisticsVehicle.list');
    this.maxUserIdleTimeMinutes = this.splitService.maxUserIdleTimeMinutes();
    this.userNameId = this.UserService.getCurrentUser().id; // Current admin user id.
  }

  $onInit() {
    this.tasksRef = this.$task();
    this.serviceAreasRef = this.$serviceArea();
    this.inActiveStatuses = this.itinerariesConstant.inActiveTaskStatuses;
    this.completedStatuses = this.itinerariesConstant.completedTaskStatuses;

    this.itineraryTotals = {};
    this.inActiveTasks = [];
    this.relatedTasks = [];
    this.hiddenAgentIds = [];
    this.relatedCompletedTasks = [];
    this.attachedLogisticsVehicles = [];
    this.isEditMode = false;
    this.editModeHasItineraryChanged = false;
    this.isExpandedTasks = true;
    this.inActiveTasksDateQuery = this.moment().toDate();
    this.selectedTasksGroup = 'Active';
    this.serviceAreasPolygons = undefined;


    this._setAgentItineraryId(this.agent);

    // this._getAgentAreasByBranches(_.get(this.agent, 'branchIds'));
    this._getAgentServiceAreas(_.get(this.agent, 'agentPreferencesReference.priorityServiceAreas', []));
    this._initItinerary();


    // this.itinerariesFacadeService.subscribeToChannels();

    // Itineraries Event Listener
    // this.itinerariesRef.$subscribeToChannelEvents((updatedItineraries: any[], action) => {
    //
    //   _.forEach(updatedItineraries, (updatedItinerary) => {
    //
    //     // Agent Itinerary
    //     if (_.isEqual(_.get(updatedItinerary, 'id'), _.get(this, 'agent.id'))) {
    //       // this.$log.debug('Itinerary PUSH:', updatedItinerary);
    //       this.editModeHasItineraryChanged = this.isEditMode;
    //
    //       // Agent Itinerary Update
    //       if (!this.isEditMode) {
    //         this._updateTotals(updatedItinerary);
    //
    //         if (!_.isEqual(this.itinerary.taskIdList, updatedItinerary.taskIdList) ||
    //           !_.isEqual(this.itinerary.taskIdListExt, updatedItinerary.taskIdListExt)) {
    //
    //           this._setTasks(updatedItinerary, this.inActiveTasks);
    //
    //           this._getInactiveTasks()
    //             .then((updatedInactiveTasks) => {
    //               this._setInactiveTasks(updatedInactiveTasks);
    //             })
    //         }
    //
    //       }
    //
    //       // Related Itineraries Update
    //       if (!_.isEqual(_.get(this.itinerary, 'relatedAgentIds'), _.get(updatedItinerary, 'relatedAgentIds'))) {
    //         this._setRelatedItineraries(updatedItinerary.relatedAgentIds);
    //       }
    //
    //       this.itinerary = updatedItinerary;
    //     }
    //
    //     // Related Itineraries
    //     const indexOf = _.findIndex(this.relatedItineraries, (relatedItinerary: any) => {
    //       return relatedItinerary.id === updatedItinerary.id;
    //     })
    //
    //     if (indexOf > -1) {
    //       if (!_.isEqual(this.relatedItineraries[indexOf].taskIdListExt, updatedItinerary.taskIdListExt)) {
    //         this._setRelatedTasks(updatedItinerary.taskIdListExt, this.relatedItineraries[indexOf].taskIdListExt);
    //       }
    //       this.relatedItineraries[indexOf] = updatedItinerary;
    //     }
    //   })
    // });

    // Tasks Event Listener
    this.tasksRef.$subscribeToChannelEvents((updatedTasks: TaskModel[], action) => {

      _.forEach(updatedTasks, (updatedTask) => {
        const taskOriginIndex = _.findIndex(this.$tasksOrigin, (t: TaskModel) => {
          return t.id === updatedTask.id;
        })
        const tasksIndex = _.findIndex(this.tasks, (t: TaskModel) => {
          return t.id === updatedTask.id;
        })
        const relatedTasksIndex = _.findIndex(this.relatedTasks, (t: TaskModel) => {
          return t.id === updatedTask.id;
        })

        if (taskOriginIndex > -1) {
          this.$tasksOrigin[taskOriginIndex] = updatedTask;
        }

        if (tasksIndex > -1) {
          const tasksCopy = angular.copy(this.tasks);
          tasksCopy[tasksIndex] = updatedTask;
          this.tasks = tasksCopy;

          this.$timeout(() => {
          }, 0)
        }

        if (relatedTasksIndex > -1) {
          const relatedTasksCopy = angular.copy(this.relatedTasks);
          relatedTasksCopy[relatedTasksIndex] = updatedTask
          this.relatedTasks = relatedTasksCopy;
        }
      })

      this._updateTotals(this.itinerary);
    });


    // Bind User Event Listeners
    this.commonsService.bindUserEvents((event) => {
      if (!!this.pushesTimeoutRef) {
        this._initPushesTimer();
      }
    })

    this._initPushesTimer();


    this._setLocations();

    this.selectLocationsSubscription = this.locationsFacadeService.selectLocations()
      .subscribe((locations) => {
        const attachedLogisticsVehiclesCopy = angular.copy(this.attachedLogisticsVehicles);
        _.forEach(locations, (updatedLocation: LocationModel) => {
          if (updatedLocation.holder === LocationHolderType.LogisticsVehicle) {
            const logisticsVehicleIndex = _.findIndex(this.attachedLogisticsVehicles, (v) => {
              return v.id === updatedLocation.holderId;
            })

            if (logisticsVehicleIndex > -1) {
              attachedLogisticsVehiclesCopy[logisticsVehicleIndex].coordinates = updatedLocation.coordinates;
            }
          }

          if (updatedLocation.holder === LocationHolderType.Agent) {
            if (_.get(this.agent, 'id') === _.get(updatedLocation, 'holderId')) {
              const agentCopy = angular.copy(this.agent);
              agentCopy.lastKnownLocation = updatedLocation;
              this.agent = agentCopy;
            }
          }
        })

        this.attachedLogisticsVehicles = attachedLogisticsVehiclesCopy;

        // Update Angularjs Cycle
        this.$timeout(0).then(() => {
        });
      })
  }

  $onChanges(changes) {
    if (changes.agent && !changes.agent.isFirstChange()) {
      this.completedRouteTasksData = undefined;

      const currentAgent = changes.agent.currentValue;
      const previousAgent = changes.agent.previousValue;

      if (!_.isEqual(_.get(currentAgent, 'id'), _.get(previousAgent, 'id'))) {
        this.selectedTasksGroup = 'Active';
        this.inActiveTasksDateQuery = this.moment().toDate();
        if (this.isEditMode) {
          this.isEditMode = false;
          this.editModeHasItineraryChanged = false;
          // if (_.isEqual(_.get(previousAgent, 'itineraryInfo.itineraryEditLockedByAdmin'), ctrl.userNameId)) {
          //     _setEditMode(previousAgent.id);
          // }
        }
        this.highlightedServiceId = undefined;
        // this._getAgentAreasByBranches(_.get(currentAgent, 'branchIds'));
        this._getAgentServiceAreas(_.get(currentAgent, 'agentPreferencesReference.priorityServiceAreas', []));
        this._initItinerary();

        this.locationsFacadeService.removeLocationsByIds(this.locationIds);
        this._setLocations();
      }
      if (!_.isEqual(currentAgent.itineraryInfo.taskIdListExt, previousAgent.itineraryInfo.taskIdListExt)) {
        if (this.isEditMode) {
          this.editModeHasItineraryChanged = true;
        }
      }
    }
  };

  $onDestroy() {
    if (_.isEqual(_.get(this.agent, 'itineraryInfo.itineraryEditLockedByAdmin'), this.userNameId)) {
      this.agentRequests.editItineraryUnlock(this.itineraryAgentId);
    }
    this._clearAllCurrentItineraryRefs();
    this._destroyPushesTimer();

    // this.itinerariesRef.$destroyChannel();
    this.tasksRef.$destroyChannel();

    this.locationsFacadeService.removeAllLocations();
    this.selectLocationsSubscription.unsubscribe();

    this.itinerarySubscription?.unsubscribe();
    this.itinerariesFacadeService.unsubscribeFromChannels();
  };

  onToggleMap() {
    this.showMap = !this.showMap;
    this.$timeout(0).then(() => {
      this.resizeService.resize();
    })
  };

  onHighlightedChanged(serviceId, highlightedTaskId) {
    this.highlightedServiceId = serviceId;
    this.highlightedTaskId = highlightedTaskId;
  }

  onItineraryTasksTabSelect(group) {
    if (!_.isEqual(this.selectedTasksGroup, group)) {
      this.completedRouteTasksData = undefined;
      this.selectedTasksGroup = group;

      this.tasks = undefined;
      this.$timeout(() => {
      }, 0)
      this._getInactiveTasks()
        .then((updatedInactiveTasks) => {
          if (_.isEqual(this.selectedTasksGroup, group)) {
            this._setInactiveTasks(updatedInactiveTasks);
          }
          if (group === 'Completed') {
            const taskLocations = _.flatMap(updatedInactiveTasks, 'taskSpec.address.location');
            if (taskLocations.length > 1) {
              this.getCompletedRouteTasksData(taskLocations);
            }
          }
          this.$timeout(() => {
          }, 0)
        })
    }
  }

  onInactiveTasksDateChange(date) {
    this.inActiveTasksDateQuery = this.moment(date).toDate();

    this._getInactiveTasks()
      .then((updatedInactiveTasks) => {
        const taskLocations = _.flatMap(updatedInactiveTasks, 'taskSpec.address.location');
        if (taskLocations.length > 1) {
          this.getCompletedRouteTasksData(taskLocations);
        }
        this._setInactiveTasks(updatedInactiveTasks);
      })
  }

  onToggleEdit() {
    this.isEditMode = !this.isEditMode;

    if (this.isEditMode) {
      this.selectedTasksGroup = 'Active';
      this.tasks = this._getEditModeTasks(this.tasks);
      this.$timeout(() => {
      }, 0)
    } else {
      this.tasks = this._filterTasksByGroup(this.$tasksOrigin, this.selectedTasksGroup);
      this.$timeout(() => {
      }, 0)
      // this._updateItinerary(this.itinerary);
      // this._setInactiveTasks(this.inActiveTasks);
    }
  }

  updateEditModeTasksOrder(taskIds) {
    const tasks = _.map(taskIds, (id) => {
      return _.find(this.tasks, (t) => {
        return t.id === id;
      })
    })
    this.tasks = this._getEditModeTasks(tasks);
    this.$timeout(() => {
    }, 0)
  }

  updateItineraryEditMode(taskIds) {
    this.agentsService.checkEditItinerary(this.itineraryAgentId, taskIds)
      .then((updatedEditItinerary: any) => {
        this.itinerariesFacadeService.setOne(updatedEditItinerary);
        // this.itinerary = updatedEditItinerary;
        this.tasks = updatedEditItinerary.taskListExt;
        this.$timeout(() => {
        }, 0)
        // this._updateItinerary(updatedEditItinerary);
      })
  }

  saveEditItinerary(taskIds) {
    this.agentsService.saveEditItinerary(this.itineraryAgentId, taskIds)
      .then((itinerary) => {
        this.isEditMode = false;
        this.editModeHasItineraryChanged = false;
        this._updateItinerary(itinerary);
      })
  }

  onResetItinerary() {
    this.agentsService.resetItinerary(this.itineraryAgentId)
      .then((itinerary) => {
        this.isEditMode = false;
        this.editModeHasItineraryChanged = false;
        this._updateItinerary(itinerary);
      })
  }

  onToggleAgent(agentId) {
    const isEnabled = !_.includes(this.hiddenAgentIds, agentId);
    if (isEnabled) {
      this.hiddenAgentIds = this.hiddenAgentIds.concat([agentId]);
    } else {
      this.hiddenAgentIds = _.filter(this.hiddenAgentIds, (id) => {
        return id !== agentId;
      })
    }
  }

  onHiddenAgentIdsChange(agentIds) {
    this.hiddenAgentIds = agentIds;
  }

  onUpdateItinerary(itinerary) {
    this.agentsService.editItinerarySettings(this.itineraryAgentId, itinerary)
      .then((updatedItinerary) => {
        this.itinerariesFacadeService.setOne(updatedItinerary);
        // this.itinerary = updatedItinerary;
      })
  }

  toggleTasksExpanded() {
    this.isExpandedTasks = !this.isExpandedTasks;
    this._setTasks(this.itinerary, this.inActiveTasks);
  }

  onToggleAssistantItinerary() {
    const itineraryAgentIdToSelect = this.itineraryAgentId === this.agent.id ?
      _.get(this.agent, 'mainAgentIds[0]') :
      _.get(this.agent, 'id');
    this._initItinerary(itineraryAgentIdToSelect);
  }

  onBindVehicle() {
    this.logisticsVehiclesDialogsService.availableLogisticVehiclesForBinding(this.agent.branchIds, this.attachedLogisticsVehicles)
      .then((logisticsVehicles) => {
        this._bindLogisticsVehiclesToAgent(this.agent.id, _.map(logisticsVehicles, 'id'), true);
      });
  }

  private _bindLogisticsVehiclesToAgent(agentId: string, logisticsVehicleIds: string[], forceUnbind?: boolean) {
    this.logisticsVehicleService.bindToAgent(agentId, logisticsVehicleIds, forceUnbind)
      .then((res) => {
        this._getAgentLogisticsVehicles(this.agent);
      });
  }

  onUnbindVehicle() {
    this.logisticsVehicleService.unbindVehicle(this.agent.id)
      .then((res) => {
        this.attachedLogisticsVehicles = [];
      });
  }

  // ******************************
  //        Private methods
  // ******************************

  private getCompletedRouteTasksData(taskLocations) {
    this.routesService.getRouteTasksData(taskLocations)
      .then((res: any) => {
        this.completedRouteTasksData = res;
        this._updateTotals(this.itinerary);
      })

  }

  private _setAgentItineraryId(agent, itineraryAgentIdToSelect?) {
    this.itineraryAgentId = itineraryAgentIdToSelect || _.get(agent, 'mainAgentIds[0]') || _.get(agent, 'id');
  }

  private _initItinerary(itineraryAgentIdToSelect?) {

    this._clearAllCurrentItineraryRefs();
    this._setAgentItineraryId(this.agent, itineraryAgentIdToSelect);

    const getItineraries = this.itinerariesService.getItineraries([this.itineraryAgentId], []);

    // this.itinerariesFacadeService.getMany({ids: [this.itineraryAgentId]});

    const getCompletedTasks = this.itinerariesService.getInActiveTasks(this.itineraryAgentId, this.moment(this.inActiveTasksDateQuery).valueOf());

    // this.itinerariesService.getInActiveTasks(this.itineraryAgentId, this.moment(this.inActiveTasksDateQuery).valueOf()).then((completedTasks) => {
    //   this.inActiveTasks = completedTasks;
    //
    //   if (!!this.itinerary) {
    //     this._setTasks(this.itinerary, this.inActiveTasks);
    //     this._setRelatedItineraries(this.itinerary.relatedAgentIds);
    //   }
    // });

    this.$q.all([getItineraries, getCompletedTasks])
      .then((response) => {
        const itinerary = response[0][0];
        const completedTasks = response[1];

        if (_.isEqual(this.itineraryAgentId, itinerary.agent.id)) {
          this.itinerariesFacadeService.setOne(itinerary);
          this.itinerariesFacadeService.subscribeToChannels([itinerary.id]);

          this.subscribeToItinerary(itinerary.id);
          // this.itinerary = itinerary;
          this.inActiveTasks = completedTasks;

          if (!!this.itinerary) {
            this._setTasks(this.itinerary, this.inActiveTasks);
            this._setRelatedItineraries(this.itinerary.relatedAgentIds);
          }
        }
      })

  }

  private subscribeToItinerary(id: string) {


    this.itinerarySubscription = this.itinerariesFacadeService.selectOne(id).subscribe(itinerary => {

      if(!itinerary) {
        return;
      }
      this.editModeHasItineraryChanged = this.isEditMode;

      // Agent Itinerary Update
      if (!this.isEditMode) {
        this._updateTotals(itinerary);

        this._setTasks(itinerary, this.inActiveTasks);

        this._getInactiveTasks()
          .then((updatedInactiveTasks) => {
            this._setInactiveTasks(updatedInactiveTasks);
          })
      }

      // Related Itineraries Update
      this._setRelatedItineraries(itinerary.relatedAgentIds);

      this.itinerary = itinerary;

      const indexOf = _.findIndex(this.relatedItineraries, (relatedItinerary: any) => {
        return relatedItinerary.id === itinerary.id;
      })

      if (indexOf > -1) {
        if (!_.isEqual(this.relatedItineraries[indexOf].taskIdListExt, itinerary.taskIdListExt)) {
          this._setRelatedTasks(itinerary.taskIdListExt, this.relatedItineraries[indexOf].taskIdListExt);
        }
        this.relatedItineraries[indexOf] = itinerary;
      }
    })

  }

  private _setTasks(itinerary, inActiveTasks) {

    const activeTaskIds = (this.isExpandedTasks ? itinerary.taskIdListExt : itinerary.taskIdList) || [];

    this.tasks = undefined;
    this.$timeout(() => {
    }, 0);
    this.tasksRef.$asyncValues(activeTaskIds)
      .then((activeTasks) => {

        // const activeTasks = (this.isExpandedTasks ? itinerary.taskListExt : itinerary.taskList) || [];

        if (!activeTasks) {
          this.tasks = [];
        }

        if (!inActiveTasks) {
          inActiveTasks = [];
        }

        this.$log.info('ACTIVE TASKS', activeTasks);

        const tasks = inActiveTasks.concat(activeTasks);
        let completedRelatedTaskIds = [];

        this.$tasksOrigin = angular.copy(tasks);
        this._updateTotals(itinerary);

        //TODO: Order by itinerary?
        this.tasks = this._filterTasksByGroup(tasks, this.selectedTasksGroup);

        _.forEach(tasks, (t) => {
          if (_.get(t, 'relations.length', false)) {
            let completedTaskIds = _.chain(t.relations)
              .filter((r) => {
                return _.get(r, 'details.status') === "CourierDeparted";
              })
              .map((filteredRelation) => {
                return filteredRelation.relatedTaskId;
              })
              .value();

            completedRelatedTaskIds = completedRelatedTaskIds.concat(completedTaskIds || []);
          }
        })

        this._setCompletedRelatedTasks(_.uniq(completedRelatedTaskIds))


        this.$timeout(() => {
        }, 0)

      })

  }

  private _updateTotals(itinerary) {
    if (itinerary) {
      let totals = angular.copy(_.get(itinerary, 'totals', {}));

      totals.activeTasksCount = this._getTasksCountByGroup(this.$tasksOrigin, 'Active');
      totals.aborted = this._getTasksCountByGroup(this.$tasksOrigin, 'Aborted');
      totals.completed = this._getTasksCountByGroup(this.$tasksOrigin, 'Completed');
      totals.allTasksCount = this._getTasksCountByGroup(this.$tasksOrigin, 'All');
      this.itineraryTotals = totals;
    }
  }

  private _updateItinerary(itinerary) {
    this.itinerariesFacadeService.setOne(itinerary);
    // this.itinerary = itinerary;

    // _updateTotals(itinerary);
    this._setTasks(itinerary, this.inActiveTasks);
  }

  private _setRelatedItineraries(relatedAgentIds) {
    if (relatedAgentIds && relatedAgentIds.length) {
      this._setRelatedItinerariesByAgentIds(relatedAgentIds)
    } else {
      this._resetRelatedItineraries();
    }
  }

  private _setRelatedItinerariesByAgentIds(relatedAgentIds) {
    this.itinerariesService.getItineraries(relatedAgentIds)
      .then((relatedItineraries) => {
        this.hiddenAgentIds = relatedAgentIds;
        this.relatedItineraries = relatedItineraries;

        let allRelatedTaskIds = [];

        _.forEach(relatedItineraries, (itinerary) => {
          allRelatedTaskIds = allRelatedTaskIds.concat(_.get(itinerary, 'taskIdListExt', []));
        })

        this._setRelatedTasks(allRelatedTaskIds);
      })
  }

  private _setRelatedTasks(relatedTaskIds, relatedTaskOldIds?) {

    if (_.isUndefined(relatedTaskIds)) {
      relatedTaskIds = [];
    }

    if (!relatedTaskOldIds) {
      relatedTaskOldIds = [];
    }

    const taskIdsToAdd = _.difference(relatedTaskIds, relatedTaskOldIds);
    const taskIdsToRemove = _.difference(relatedTaskOldIds, relatedTaskIds);

    // this.$log.info('RELATED TASKS', relatedTaskIds)
    this.tasksRef.$asyncValues(taskIdsToAdd)
      .then((tasks) => {
        // ctrl.relatedTasks = _.filter(ctrl.relatedTasks, function(t) {
        //     return !_.includes(relatedTaskIds, t.id);
        // });
        let relatedTasksCopy = angular.copy(this.relatedTasks);
        relatedTasksCopy = _.filter(relatedTasksCopy, (task: TaskModel) => {
          return !_.includes(taskIdsToRemove, task.id)
        })

        this.relatedTasks = _.uniqBy(relatedTasksCopy.concat(tasks, this.relatedCompletedTasks), 'id');
      })

  }

  // private _updateEditItinerary(itinerary) {
  //   this.itinerary = itinerary;
  //   this.tasks = itinerary.taskListExt
  //
  //   this._updateTotals(itinerary);
  // }

  private _getEditModeTasks(tasks) {
    return _.filter(tasks, (t) => {
      return !_.includes(this.inActiveStatuses, t.status);
    })
  }

  private _getTasksCountByGroup(tasks, group) {
    return this._filterTasksByGroup(tasks, group).length;


    // let count = 0;
    // _.forEach(tasks, (t) => {
    //   const isBundle = _.isEqual(t.taskType, 'BundledStopover');
    //   if (isBundle) {
    //     _.forEach(t.bundledTaskList, (bundledTask) => {
    //       _switchTask(bundledTask, group)
    //     })
    //   } else {
    //     _switchTask(t, group)
    //   }
    // });

    // function _switchTask(task, group) {
    //   switch (group) {
    //     case 'All':
    //       count++
    //       return true;
    //     case 'Completed':
    //       if (_.includes(this.completedStatuses, task.status)) {
    //         count++
    //       }
    //       return;
    //     case 'Aborted':
    //       if (task.status === 'Canceled') {
    //         count++
    //       }
    //       return;
    //     case 'Active':
    //       if (task.status !== 'Canceled' &&
    //         task.status !== 'CourierDeparted' &&
    //         task.taskType !== 'Internal') {
    //         count++
    //       }
    //       return;
    //     default:
    //       return false
    //   }
    // }
    //
    // return count;
  }

  private _filterTasksByGroup(tasks, group) {
    return _.filter(tasks, (t) => {
      switch (group) {
        case 'All':
          return true;
        case 'Completed':
          return _.includes(this.completedStatuses, t.status);
        case 'Aborted':
          return t.status === 'Canceled'
        case 'Active':
          return !_.includes(this.inActiveStatuses, t.status);
        default:
          return false
      }
    });
  }

  private _clearAllCurrentItineraryRefs() {
    this.itineraryTotals = {};
    this.hiddenAgentIds = [];
    this._resetAgentItinerary();
    this._resetRelatedItineraries();
  }

  private _getInactiveTasks() {
    return this.itinerariesService.getInActiveTasks(this.itineraryAgentId, this.moment(this.inActiveTasksDateQuery).valueOf());
  }

  private _setInactiveTasks(inactiveTasks) {
    this.inActiveTasks = inactiveTasks;

    let updatedTaskOrigin = _.filter(this.$tasksOrigin, (t) => {
      return !_.includes(this.inActiveStatuses, t.status);
    })
    this.$tasksOrigin = inactiveTasks.concat(updatedTaskOrigin);

    this._updateTotals(this.itinerary);

    if (this.selectedTasksGroup === 'All') {
      this.tasks = angular.copy(this.$tasksOrigin);
    } else {
      this.tasks = this._filterTasksByGroup(this.$tasksOrigin, this.selectedTasksGroup);
    }

    this.$timeout(() => {
    }, 0)


  }

  private _setCompletedRelatedTasks(taskIds) {
    //TODO loader.
    this.relatedCompletedTasks = [];
    this.tasksRef.$asyncValues(taskIds)
      .then((relatedCompletedTasks) => {
        this.relatedCompletedTasks = relatedCompletedTasks;
        this.relatedTasks = _.uniqBy(this.relatedTasks.concat(relatedCompletedTasks), 'id');
      })
  }

  private _resetAgentItinerary() {
    // this.itinerariesFacadeService.setOne(itinerary);
    if (!!this.itinerary) {
      this.itinerariesFacadeService.removeByIds([this.itinerary.id]);
    }
    this.itinerary = undefined;
    this.tasks = undefined;
    this.inActiveTasks = [];

    this.itineraryCopy = undefined;
    this.$tasksOrigin = undefined;

    this.$timeout(() => {
    }, 0)
  }

  private _resetRelatedItineraries() {
    this.relatedItineraries = undefined;
    this.relatedTasks = [];
    this.relatedCompletedTasks = [];
  }

  private _getAgentServiceAreas(serviceAreaIds) {
    if (serviceAreaIds.length) {
      this.serviceAreasRef.$asyncValues(serviceAreaIds)
        .then((serviceAreas) => {
          this.agentServiceAreas = serviceAreas;
          this.serviceAreasPolygons = serviceAreas;
        })
    } else {
      this.agentServiceAreas = [];
      this.serviceAreasPolygons = [];
    }
  }

  private _getAgentLogisticsVehicles(agent) {
    this.attachedLogisticsVehicles = [];

    this.logisticsVehicleService.getCurrentBoundedByAgent(agent.id)
      .then((attachedLogisticsVehicles) => {
        this.attachedLogisticsVehicles = attachedLogisticsVehicles;
        if (attachedLogisticsVehicles.length) {
          const payload = _.map(attachedLogisticsVehicles, (v) => {
            return {
              holderId: v.id,
              holder: LocationHolderType.LogisticsVehicle
            }
          })
          this.locationsFacadeService.getLocations(payload);
        }
      })
  }

  private _setLocations() {
    this.locationIds = [];
    this.locationIds.push(this.agent.id);
    let payload = [{holderId: this.agent.id, holder: LocationHolderType.Agent}];

    if (!!this.hasLogisticsVehiclePermission) {
      this.logisticsVehicleService.getCurrentBoundedByAgent(this.agent.id)
        .then((logisticsVehicles) => {
          this.attachedLogisticsVehicles = logisticsVehicles;
          logisticsVehicles.forEach(logisticVehicle => {
            this.locationIds.push(logisticVehicle.id);
            payload.push({
              holderId: logisticVehicle.id,
              holder: LocationHolderType.LogisticsVehicle
            })
          })
          this.locationsFacadeService.getLocations(payload);
        });
    } else {
      this.locationsFacadeService.getLocations(payload);
    }
  }

  private _initPushesTimer() {
    this._destroyPushesTimer();

    this.pushesTimeoutRef = this.$timeout(() => {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;

      this.commonsDialogService.stillThereConfirm()
        .then((continueSession) => {
          if (continueSession) {
            this._initPushesTimer();

            //Sync Tasks/Itinerary
            this._initItinerary();
          }
        })
    }, (this.maxUserIdleTimeMinutes * 60000));
  }

  private _destroyPushesTimer() {
    if (this.pushesTimeoutRef) {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentItineraryView', {
    bindings: {
      agent: '<',
      showAgentInfo: '<',
      onAgentSelect: '&',
      onClose: '&?'
    },
    template: require('./agent-itinerary-view.html').default,
    controller: AgentItineraryViewCtrl
  });
